<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="700px">
    <v-card>
      <v-card-title class="pa-0">
        <v-col class="text-end py-0 px-0" cols="12">
          <v-btn class="pa-0" icon dark @click="clean()">
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col class="text-center pt-0" cols="12">
          <h1 style="font-size: 24px" class="mb-3 mt-0">
            Protocolo único
          </h1>
          <p style="font-size: 14px; line-height: 18px" class="mb-2">
            Deseja aplicar este protocolo e/ou data de envio a todos os lotes?
          </p>
        </v-col>
        <v-row  wrap class="px-7 ma-0">
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">{{info.oper_nome}}</span>
            <span  class="card-title-form-guia" style="font-weight:normal; display: block">{{info.prest_nome }}</span>
          </v-col>
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">Data do pagamento: </span>
            <span style="font-size:16px;font-weight:bold">{{info.data_pagamento | formatDate}}</span>
          </v-col>
          <v-col class="text-left pb-4 pt-0" cols="4">
            <span class="card-title-form-guia textsRec" style="display: block">Total Recursado (R$): </span>
            <span style="font-size:16px;font-weight:bold; color: green">{{ info.valor_recursado | formatPrice }}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="px-10 pt-0 pb-2">
        <v-form ref="protocoloRecursoForm" :value="formValid">
          <v-row>
          <v-col class="py-0 px-3 ma-0" cols="6">
            <label style="margin-bottom: 2px">Data do envio</label>
            <v-menu
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="formData.data_envio = parseDate(dateFormatted)"
                  :rules="[formRules.requiredField, formRules.typeDateFormated]"
                ></v-text-field>
                  <!-- :rules="formRules.required" -->
              </template>
              <v-date-picker
                color="primary"
                v-model="formData.data_envio"
                @input="dateFormatted = formatDate(formData.data_envio)"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0 px-3 ma-0" cols="6">
            <label>Número do protocolo</label>
             <v-text-field
              v-model="formData.protocolo_envio"
              small
              height="30px"
              placeholder="Opcional"
              single-line
              outlined
              dense
              hide-details
              :rules="[formRules.max20]"
            ></v-text-field>
          </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="px-6 pb-1 pt-2">
        <v-col class="text-left px-4 pb-4 pt-0" cols="6">
          <v-btn
            height="30px"
            small
            color="primary"
            depressed
            outlined
            @click="clean()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col class="text-right px-5 pb-6 pt-0" cols="6">
           <v-btn
            height="30px"
            class="mr-3"
            small
            color="error"
            depressed
            @click="DeleteProtocoloConfirm()"
          >
            Excluir Protocolo
          </v-btn>
          <v-btn color="primary" height="30px" small depressed @click="save()">
            Salvar
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
// import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      formData: {
        lote_id: null,
        data_envio: null,
        protocolo_envio: ""
      },
      dateFormatted: null,
      formValid: true,
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
  },
  mounted() {
    this.formData = Object.assign(this.formData, this.protocolo_pagamento)
    this.dateFormatted = this.formatDate(this.formData.data_envio)
    if(this.$refs && this.$refs.protocoloRecursoForm){
          this.$refs.protocoloRecursoForm.resetValidation()
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.clean();
      } else {
        this.formData = Object.assign(this.formData, this.protocolo_pagamento)
        this.dateFormatted = this.formatDate(this.formData.data_envio)
        if(this.$refs && this.$refs.protocoloRecursoForm){
          this.$refs.protocoloRecursoForm.resetValidation()
        }
      }
    },
    dateFormatted(val) {
      this.formData.data_envio = this.parseDate(val);
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    clean() {
      this.$refs.protocoloRecursoForm.reset();
      this.$refs.protocoloRecursoForm.resetValidation();
      this.close();
    },
    save() {
      if (this.$refs.protocoloRecursoForm.validate()) {
        let {prestador_id, operadora_ans_id, data_pagamento } = this.info
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloLotesRecursados",
              payload: {
                data_pagamento,
                grupo_economico: this.grupoEconomico,
                operadora_ans_id,
                pagamento_id: this.info.id,
                prestador_id,  
                protocolos:[this.formData]
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { this.clean(); this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });
      }
    },
    DeleteProtocoloConfirm(){
        let paramModal = {
          type: "warning",
          title: "Exclusão de protocolo",
          message: "Deseja realmente excluir este protocolo?",
          callback: () => this.DeleteProtocolo(),
          btConfirm: { name: "Excluir", show: true, color: 'warning'},
          btCancel: { name: "Não", show: true },
        };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);  

    },
     DeleteProtocolo(){
        let {prestador_id, operadora_ans_id, data_pagamento } = this.info
        let obj = {
          query: [
            {
              modulo: "Recebiveis",
              acao: "AddProtocoloLotesRecursados",
              payload: {
                data_pagamento,
                grupo_economico: this.grupoEconomico,
                operadora_ans_id,
                pagamento_id: this.info.id,
                prestador_id,  
                protocolos:[{lote_id: null, data_envio: null, protocolo_envio: ""}]
              },
            },
          ],
        };
        this.$store
          .dispatch("request/doRequest", obj, { root: true })
          .then((response) => {
            if (!response || response.isAxiosError || response.erros.length) {
              this.$store.commit("hideLoader");
              return;
            }
            let paramModal = {
                type: "success",
                title: "Sucesso",
                message: response.mensagem,
                callback: ()=> { this.clean(); this.updatePage()},
                btConfirm: { name: "Ok", show: true },
                btCancel: { name: "Não", show: false },
              };
              this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          });

     }
  },
  props: {
    close: Function,
    dialog: Boolean,
    grupoEconomico: Number,
    info: Object,
    protocolo_pagamento: Object,
    updatePage: Function
  },
};
</script>

<style>
.button-histor:focus {
  outline: none;
}
.card-title-form-guia {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
.textsRec {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
</style>